import type { CashSource, SalePaymentMethod } from "@artisancode/api-types";

export const CASH_SOURCE_LABELS: Record<CashSource, string> = {
  office: "Kantor",
  rider: "Rider",
  receivable_payment: "Pelunasan Piutang",
};

export const CASH_METHOD_LABELS: Record<SalePaymentMethod, string> = {
  cash: "Tunai",
  edc: "EDC",
  qris: "QRIS",
  app_qris: "App QRIS",
  bank_transfer: "Transfer",
  credit_unpaid: "Kasbon/Belum Bayar",
};
